import { PulsarPayload } from "ExtendiApp"
import React from "react"

import { Card, CardFooter, CardBody, LineChart } from "src/ui"
import {
  fromPulsarPayloadToLineChart,
  getTotalTweetsFromPulsarPayload,
} from "src/utils/graph"

interface Props {
  topic: string
  description: string

  data: PulsarPayload
  legend: string[]
  url: string
}

export const CardChart: React.FC<Props> = ({
  topic,
  description,
  data,
  legend,
  url,
}) => {
  return (
    <Card className="chart d-flex justify-content-between h-100 px-4 py-4">
      <CardBody className="p-0">
        <h4 className="font-weight-normal text-dark mb-0">{topic}</h4>
        <p className="small mb-3"> {getTotalTweetsFromPulsarPayload(data)}</p>

        <div style={{ height: 90 }} className="mx-n4 mb-2">
          {data && data.length ? (
            <LineChart
              height={90}
              data={fromPulsarPayloadToLineChart(data, legend)}
              thing={"tweets"}
            />
          ) : null}
        </div>

        <p className="mt-3 mb-2">{description}</p>
      </CardBody>

      <CardFooter className="w-100 text-center">
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-uppercase font-weight-bold text-decoration-none"
        >
          View full trend
        </a>
      </CardFooter>
    </Card>
  )
}
